var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLubricant4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 48,
    viewBox: "0 0 134 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 134,
    height: 48,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.9097 23.392L57.9935 31.6344L55.0384 23.392H51.4722L56.233 35.9733H59.6031L64.3191 23.392H60.9097Z",
    fill: "#002169"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.59 23.2988H72.4384V35.9921H75.59V23.2988Z",
    fill: "#002169"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8706 23.2988H95.7192V35.9921H98.8706V23.2988Z",
    fill: "#002169"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M82.734 26.0836L81.0519 32.6414L79.3416 26.0836L76.0163 26.0772L78.9996 35.992H82.8351L85.8015 26.0836H82.734Z",
    fill: "#002169"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M103.023 26.0837H99.8658V35.9921H103.023V26.0837Z",
    fill: "#002169"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M103.023 23.2988H99.8658V25.1635H103.023V23.2988Z",
    fill: "#002169"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M110.178 26.0837H104.026V35.9921H107.172V28.1349H109.538V35.9921H112.695V28.6072C112.695 26.6244 111.563 26.0837 110.178 26.0837Z",
    fill: "#002169"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4244 35.9921C93.961 35.9921 94.7235 35.1713 94.7235 33.6548C94.7235 32.3057 94.7293 28.5203 94.7293 28.5203C94.7293 26.4939 93.518 26.0837 92.3908 26.0837H88.2805C87.1534 26.0837 85.9421 26.4939 85.9421 28.5203C85.9421 28.5203 85.9478 32.3057 85.9478 33.6548C85.9478 35.1713 86.7104 35.9921 88.2524 35.9921H92.4244ZM89.1272 33.9346V28.1785L91.5496 28.1225V33.9346H89.1272Z",
    fill: "#002169"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M71.407 28.6135C71.407 26.6244 70.2686 26.0837 68.7211 26.0837H64.2181L63.5172 27.9484C64.3809 27.9484 68.2669 27.9484 68.2669 27.9484V29.3596H65.0817C63.7863 29.3596 62.575 29.8319 62.575 31.8894C62.575 33.089 62.575 33.8165 62.575 33.8165C62.575 35.2958 63.3714 35.9921 65.0088 35.9921C66.2594 35.9921 71.407 35.9858 71.407 35.9858V28.6135ZM68.2669 33.9346H65.5919V31.2243H68.2669V33.9346Z",
    fill: "#002169"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M113.626 28.744C113.626 30.0744 113.626 33.4559 113.626 33.4559C113.626 34.3633 113.912 34.9043 114.103 35.1465C114.512 35.6688 115.163 35.9921 116.329 35.9921H121.354L121.802 34.1211C120.933 34.1211 116.766 34.1211 116.766 34.1211V32.5234H120.109C121.494 32.5234 122.346 31.9454 122.346 30.2236C122.346 29.0238 122.346 28.3774 122.346 28.3774C122.346 26.5808 121.275 26.0837 119.867 26.0837C119.043 26.0837 117.737 26.0837 116.307 26.0837C114.731 26.0837 113.626 26.8357 113.626 28.744ZM116.766 28.1349H119.441V30.6587H116.766V28.1349Z",
    fill: "#002169"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M123.143 34.4961V34.0238H124.718V34.4961H124.186V36.0005H123.664V34.4961H123.143ZM125.616 34.0238L125.941 35.1612L126.26 34.0238H127.001V36.0005H126.53V34.5705L126.137 36.0005H125.739L125.352 34.5705V36.0005H124.875V34.0238H125.616Z",
    fill: "#002169"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3364 35.9774H37.2887L29.8125 23.5156L22.3364 35.9774Z",
    fill: "#002169"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3497 11H7L22.3359 35.9772L29.812 23.5153L22.3497 11Z",
    fill: "#E1251B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M37.336 11L29.8115 23.5153L37.2878 35.9772L52.6858 11H37.336Z",
    fill: "#0082CA"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1318 34.4873V34.0146H43.7075V34.4873H43.1749V35.9914H42.659V34.4873H42.1318ZM44.6047 34.0146L44.93 35.1524L45.2495 34.0146H45.9897V35.9914H45.5188V34.5617L45.1318 35.9914H44.7282L44.3411 34.5681V35.9914H43.8645V34.0146H44.6047Z",
    fill: "#002169"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLubricant4);
export default __webpack_public_path__ + "static/media/lubricant4.5744361b55b1c016b1dd81bb87028182.svg";
export { ForwardRef as ReactComponent };